export const environment = {
  mockData: false,
  production: true,
  apiUrl: 'https://api-wix-bundle-qa.trustedshops.com/v1/api',
  delayBeforeOpenRatingDialog: 60000,
  ratingUrl: 'https://www.wix.com/app-market/add-review/4750adaf-e490-4372-8e70-1d8d95fe633a',
};
